import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deleteSubjectUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createSubjectHttpRepository(tokenProvider);
  await repository.delete(id);
};
